export const GENESIS_TARGET_RAISE = 1_000_000n * 10n ** 18n
export const PRE_GENESIS_USDT_RAISED = 2_300_000n * 10n ** 18n
export const PRE_GENESIS_BCDX_SUPPLY = 4_182_000n * 10n ** 18n

/** Combine the pre-Genesis allocation with live Curve figures for public totals.
 * The additional $1M Genesis target deliberately remains curve-only. */
export function aggregateGenesisStats(curveSold = 0n, curveRaised = 0n) {
  return {
    totalSupply: PRE_GENESIS_BCDX_SUPPLY + curveSold,
    totalLocked: PRE_GENESIS_BCDX_SUPPLY + curveSold,
    totalRaised: PRE_GENESIS_USDT_RAISED + curveRaised,
    genesisRemaining: GENESIS_TARGET_RAISE > curveRaised
      ? GENESIS_TARGET_RAISE - curveRaised
      : 0n,
  }
}
